var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDigitalCockpit24 = function SvgDigitalCockpit24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.044 18.34a4.534 4.534 0 1 0 0-9.068 4.534 4.534 0 0 0 0 9.067Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.335 15.988a2.77 2.77 0 1 1 3.431 0m-2.281.715h1.12",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.017 11.516-1.274 2.573-.051.11a.756.756 0 0 1-1.133.187",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.052 11.54-2.413 1.578-.102.062a.756.756 0 0 0-.05 1.149",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.123 11.373a3.654 3.654 0 1 1-.011 4.858",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.468 15.564a2.23 2.23 0 1 1 2.766 0m-1.839.576h.902",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.876 11.373a3.654 3.654 0 1 0 .012 4.858",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53 15.564a2.231 2.231 0 1 0-2.764 0m1.839.576h-.902m-1.557-3.03h4.027m-4.027 1.44h4.027m9.792-1.44h3.886m-3.886 1.44h3.886",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7c1.855-1.218 4.753-2 8.01-2 3.255 0 6.127.779 7.99 1.99",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDigitalCockpit24;